// Fix jQuery passive listener
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        }
    }

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px")); // We listen to the resize event

    window.addEventListener('resize', debounce(function(){
        // We execute the same script as before
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    }, 100));

    // Verificar qual tamanho da barra de rolagem
    function getScrollbarWidth() {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
    }

    var scrollbar = getScrollbarWidth();

    // Menu mobile vars
    var hamburger = document.querySelector(".hamburger");
    var toogleMenu = document.querySelectorAll('.toggle-menu');
    var wrapper = document.querySelector('.menu-wrapper');
    var menuMobileOverlay = $('.menu-mobile-overlay');

    for (var i = 0; i < toogleMenu.length; i++){
        toogleMenu[i].addEventListener('click', menuAction);
    }

    // Search vars
    var toggleSearch = $('[data-search="toggle"]');
    var searchOverlay = $('.search-overlay');
    var screenSearch = $('.header-search-block');

    // Open menu mobile
    function openMenuMobile() {
        menuMobileOverlay.fadeIn();
        wrapper.classList.add('show-menu');
        hamburger.classList.add('is-active');
        if (screenSearch.is(':visible')) {
            closeSearchMobile();
        }
    }

    // Close menu mobile
    function closeMenuMobile() {
        menuMobileOverlay.fadeOut();
        wrapper.classList.remove('show-menu');
        hamburger.classList.remove('is-active');
    }

    // Open search
    function openSearchMobile() {
        screenSearch.addClass('is-active');
        screenSearch.fadeIn();
        searchOverlay.fadeIn();
        screenSearch.find('.search-field').focus();
        if (wrapper.classList.contains('show-menu')) {
            closeMenuMobile();
        }
    }

    // Close search
    function closeSearchMobile() {
        screenSearch.removeClass('is-active');
        screenSearch.fadeOut();
        searchOverlay.fadeOut();
    }

    // Trigger menu mobile
    function menuAction() {
        if(wrapper.classList.contains('show-menu')){
            closeMenuMobile();
        }
        else {
            openMenuMobile();
        }
    }

    // Open submenu mobile
    $('.mobile-nav .menu-item-has-children').click(function(event) {
        $('.mobile-nav .sub-menu .menu-item').click(function(event) {
            event.stopPropagation();
        });
        if ($(this).children('.sub-menu').is(':visible')) {
            $(this).removeClass('is-active');
            $(this).children('.sub-menu').slideUp();
        } else {
            $(this).addClass('is-active');
            $(this).children('.sub-menu').slideDown();
        }
    });

    // Trigger search mobile
    $(toggleSearch).click(function() {
        if (screenSearch.hasClass('is-active')) {
            closeSearchMobile();
        } else {
            openSearchMobile();
        }
    });

    // Open equipe-popup
    var scrollbar = getScrollbarWidth();
    var pItem = $('.popup-block');
    var pOverlay = $('.popup-overlay');

    $('body').on('click', '[data-popup="open"]', function(event) {
        var eItem = $(this).closest('.equipe-item').html();

        pItem.find('.popup-padding').html(eItem);
        pItem.fadeIn();
        pOverlay.fadeIn();

        $('html').css({'margin-right': scrollbar+'px', 'overflow': 'hidden'});
    });

    // Close equipe-popup
    $('body').on('click', '[data-popup="close"]', function(event) {
        pItem.fadeOut();
        pOverlay.fadeOut();

        setTimeout(function(){
            $('html').css({'margin-right': '', 'overflow': ''});
        }, 300);
    });

    // Open cat-blog menu
    $('[data-cat-mobile="toggle"]').click(function() {
        $(this).toggleClass('is-active');
        $(this).siblings('.cat-list').slideToggle();
    });

    // Open footer menu
    $('#footer-menu-btn').click(function() {
        $(this).toggleClass('is-active');
        $(this).siblings('.custom-menu-class').slideToggle();
    });

    // Trigger whatsapp (open/close)
    var whatsappPopup = $('#whatsapp-popup');

    $('[data-whatsapp-popup="toggle"]').click(function(event) {
        whatsappPopup.toggleClass('is-active');
        whatsappPopup.fadeToggle('fast');
        if (whatsappPopup.hasClass('is-active')) {
            $(whatsappPopup).find('input:first').focus();
            $('html').css({'overflow': 'hidden'});
        } else {
            setTimeout(function(){
                $('html').css({'overflow': ''});
            }, 300);
        }
    });

    // Nome do arquivo no input
    if ($("body").has("#input-file").length) {
        // click input file
        $('#input-file-btn').click(function() {
            $('#input-file').click();
        });

        var defaultText = $("#input-file-name").text();

        $('#input-file').bind('change', function(){
            $("#input-file-name").html(this.value.split(/(\\|\/)/g).pop());
            if ($('#input-file-name').is(':empty')){
                $("#input-file-name").html(defaultText);
            }
        });
    }

    // Anchor scroll
    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr('href'));
            var target = hash.length ? hash : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);

                // Fechar menu mobile
                closeMenuMobile();

                // Mudar hash na URL
                history.pushState({}, '', el.href);
            }
        }
    });

    $('a[href="#"]').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
        // Fechar menu mobile
        closeMenuMobile();
    });

    /*
    var hash = location.hash;

    if ($("body").has(hash).length) {
        $('html, body').animate({
            scrollTop: $($(hash).offset().top)
        }, 1000);
    }
    */

    $('.gallery-popup, .wp-block-gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            tLoading: 'Carregando a imagem...',
            mainClass: 'mfp-no-margins mfp-fade',
            removalDelay: 300,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'A imagem não pode ser carregada.',
            },
        });
    });
});
//# sourceMappingURL=data:application/json;charset=utf8;base64,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
